import React from 'react'
import { defaultProps } from './index'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const ZoomImageSettings = (settingsProps) => {
  return <>{!settingsProps.floating && <ImageToolbarSection defaultProps={defaultProps} />}</>
}

export const ZoomImageFloatingSettings = () =>
  React.createElement(ZoomImageSettings, { floating: true })
